<template>
    <div class="d-flex justify-content-center">
        <div class="download-message mt-3">
            <span v-if="error" class="text-danger">
                <b>{{ error }}</b>
                <br/>
                <router-link to="/settings#integrations">Back to Integrations</router-link>
            </span>
            <span v-else>Connecting your Theta Lake account&hellip;</span>
        </div>
    </div>
</template>

<script>
/**
 * Landing page for Theta Lake's server-initiated OAuth 2.0 flow (DEV-2843).
 *
 * Routed at /apis/thetalake/enable. Named for what it does — completing the Enable step
 * the user started — rather than for Theta Lake's "User Login URL" field label, since it
 * logs nobody in and would otherwise read like a competing login route.
 *
 * Registered as the "User Login URL" on the Theta Lake application. Their server sends the
 * browser here after a Portal user enables our app, with `state` (the User Login State we
 * registered) and a `parameter_token` on the query string.
 *
 * This route only captures those values and returns the user to Integrations, where the
 * button now reads Connect instead of Enable. It deliberately does not start the
 * authorization redirect itself: the user may not be logged into UpContent yet, and the
 * router's auth guard needs the chance to send them through login first.
 */
import { setParameterToken } from '@/services/ThetalakeParameterToken';

export default {
    name: 'ThetalakeEnable',
    data() {
        return { error: null };
    },
    mounted() {
        const { parameter_token: parameterToken, state } = this.$route.query;

        if (!parameterToken) {
            // Someone reached this URL without coming through Theta Lake. Say so plainly
            // rather than silently bouncing to Integrations, where the button would still
            // read Enable and the cause would be invisible.
            this.error = 'This link is missing the Theta Lake authorization details. '
                + 'Please start again from the Theta Lake portal.';
            return;
        }

        if (!setParameterToken(parameterToken, state)) {
            this.error = 'Your browser is blocking session storage, which Theta Lake\'s '
                + 'connection flow requires. Please enable it, or try a different browser.';
            return;
        }

        this.$router.push('/settings#integrations');
    }
};
</script>
